import { Component, ViewChild } from '@angular/core';
import { DataService } from '../services/data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Table } from 'primeng/table';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-sample-list',
  templateUrl: './sample-list.component.html',
  styleUrls: ['./sample-list.component.css']
})
export class SampleListComponent {
  constructor(private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService){}
  
    @ViewChild('dt') dt: Table | undefined;
  
    sampleList: any[] = [];
    loading: boolean = true;
    sendingData: boolean = false;
    selectedSample: any;
    cols: any[] = [];
    runId: number = 0;
  
    ngOnInit() {
      const filters = localStorage.getItem("filters");
      const id = this.route.snapshot.paramMap.get('runId');
      this.runId = +id!;
      //this.sampleList.push({sampleId:123, runName: "testrun123", sampleName: "testsample123", totalSeqs: 8128398512, seqQual: "30.3", isApproved:true, isRetested:false})
      //this.loading = false;
      this.loadData(this.runId);
  
      this.cols = [
        { field: 'name', header: 'Sample Name' },
        { field: 'isControl', header: 'Control' },
        { field: 'yield', header: 'Yield' },
        { field: 'qualityScore', header: 'Quality Score' },
        { field: 'approvalDate', header: 'Approval Date' },
        { field: 'retestDate', header: 'Retest Date' }
      ];
    }
  
    clear(table: Table) {
      table.clear();
    }
  
    rowClick(record: any){
      //this.router.navigate(['detail',snpRecord.sampleId]);
    }
  
    viewQC(record: any){
      console.log(record);
      this.router.navigate(['sample-detail', {sampleId: record.sampleId}]);
    }
  
    approve(record: any){
      this.sendingData = true;
      this.dataService.approveSample(record.sampleId)
        .then(data => {
          this.messageService.add({severity:'success', summary:'Approved sample ' + record.name + ' successfully.'});
          this.loadData(this.runId);
        })
        .catch(error => {
          this.messageService.add({severity:'error', summary:'Sample ' + record.name + ' could not be approved.'});
          this.sendingData = false;
        });
    }
  
    retest(record: any){
      this.dataService.retestSample(record.sampleId)
        .then(data => {
          this.messageService.add({severity:'success', summary:'Retested sample ' + record.name + ' successfully.'});
          this.loadData(this.runId);
        })
        .catch(error => {
          this.messageService.add({severity:'error', summary:'Sample ' + record.name + ' could not be retested.'});
        });
    }

    loadData(id: number){
      this.dataService.getSampleList(id).then(data => {
        this.sampleList = data;
        this.loading = false;
        this.sendingData = false;
      });
    }

    sendSampleToOC(record: any){
      this.sendingData = true;
      this.dataService.sendSampleToOC(record.sampleId)
        .then(data => {
          this.messageService.add({severity:'success', summary:'Sample ' + record.name + ' successfully sent.'});
          this.loadData(this.runId);
        })
        .catch(error => {
          this.messageService.add({severity:'error', summary:'Sample ' + record.name + ' could not be sent.'});
          this.sendingData = false;
        });
    }

    sendCompleteEmail(){
      this.loading = true;
      this.dataService.sendCompleteEmail(this.runId)
        .then(data => {
          this.loading = false;
          this.messageService.add({severity:'success', summary:'Run complete email sent.'});
        })
        .catch(error => {
          this.loading = false;
          this.messageService.add({severity:'error', summary:'Run complete email could not be sent.'});
        });
    }
}
